import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { connect } from 'react-redux'
import { CellMeasurer } from 'react-virtualized'
import { isSameDay } from 'date-fns'
import { Link } from 'react-router-dom'

import { selectors as NotesSelectors } from 'data/notes'
import { selectors as UsersSelectors } from 'data/users'

import { NoteIcon } from 'components/Utils/Icons'
import RoutesHelper from 'helpers/RoutesHelper'
import AvatarGroup from 'components/Utils/AvatarGroup'

import Item from './Item'
import { getHumanReadableDate, stripRepetitiveActivities } from '../utils'

const enhance = connect((state, { noteActivities }) => {
  const firstNoteActivity = noteActivities[0]
  const note = NotesSelectors.getNote(state, firstNoteActivity.get('noteId'))
  const creator = UsersSelectors.getUser(state, note.get('createdBy'))

  return {
    note,
    creator,
  }
})

class ActivityRowBlock extends React.Component {
  state = {
    hovering: false,
  }
  static propTypes = {
    note: PropTypes.object.isRequired,
    noteActivities: PropTypes.array.isRequired,
    previousNoteActivities: PropTypes.array,
  }

  renderDay() {
    const { previousNoteActivities, noteActivities } = this.props

    if (
      previousNoteActivities &&
      isSameDay(
        noteActivities[0].get('createdAt'),
        previousNoteActivities[0].get('createdAt')
      )
    ) {
      return false
    }

    return (
      <div
        className={classNames(
          'activity-row',
          'margin-left-auto margin-right-auto margin-top-large margin-bottom-normal',
          'font-weight-bold shade-10'
        )}
      >
        {getHumanReadableDate(noteActivities[0].get('createdAt'))}
      </div>
    )
  }

  onHover = () => {
    this.setState({ hovering: true })
  }
  onLeave = () => {
    this.setState({ hovering: false })
  }

  renderNoteTitle() {
    const { note } = this.props

    const to = RoutesHelper.noteChannelShow({
      noteId: note.get('id'),
      channelId: note.get('channelId'),
      noteTitle: note.get('title'),
    })

    return (
      <Link
        to={to}
        className="block margin-horizontall-small padding-medium background-shade-100"
      >
        <span
          className={classNames(
            'font-weight-medium entity-highlight',
            'padding-vertical-smaller padding-horizontal-smaller'
          )}
        >
          <span
            className="padding-right-smaller margin-left-smallest"
            style={{ verticalAlign: '2px' }}
          >
            <NoteIcon size={12} />
          </span>{' '}
          {note.get('title')}
        </span>
      </Link>
    )
  }

  renderNoteCreation() {
    const { creator, note, noteActivities } = this.props
    const firstNoteActivity = noteActivities[0]

    const hasCreator = Boolean(creator)
    const createdSameDay = isSameDay(
      note.get('createdAt'),
      firstNoteActivity.get('createdAt')
    )

    if (!hasCreator || !createdSameDay) {
      return false
    }

    const to = RoutesHelper.noteChannelShow({
      noteId: note.get('id'),
      channelId: note.get('channelId'),
      noteTitle: note.get('title'),
    })

    return (
      <Link
        to={to}
        className="activity-row-item block background-shade-100 margin-top-smaller shadow-normal-on-hover position-relative"
        onMouseEnter={this.onHover}
        onMouseLeave={this.onLeave}
        style={{
          zIndex: this.state.hovering ? 3 : 1,
        }}
      >
        <div className="activity-row-item-inner transition flexbox shade-10 margin-horizontall-small padding-medium">
          <div className="flexbox-grow">
            <span role="img">{'✨ '}</span>
            <span className="font-weight-bold capitalize">
              {creator.get('username')}
            </span>{' '}
            created it
          </div>
          <div className="flexbox-no-shrink padding-left-medium">
            <AvatarGroup users={[creator]} size="small" />
          </div>
        </div>
      </Link>
    )
  }

  render() {
    const { noteActivities, cache, index, parent, style } = this.props

    return (
      <CellMeasurer
        cache={cache}
        columnIndex={0}
        rowIndex={index}
        parent={parent}
      >
        <div
          className="activity-row-container padding-top-large"
          style={{
            ...style,
            right: 0,
          }}
        >
          {this.renderDay()}
          <div
            className={classNames(
              'activity-row',
              'radius-normal',
              'margin-left-auto margin-right-auto'
            )}
          >
            {this.renderNoteTitle()}
            {stripRepetitiveActivities(noteActivities).map(
              (noteActivity, index) => (
                <Item key={index} noteActivity={noteActivity} />
              )
            )}
            {this.renderNoteCreation()}
          </div>
        </div>
      </CellMeasurer>
    )
  }
}

export default enhance(ActivityRowBlock)
